/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ShareFillIcon = function ShareFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M16 2C13.7909 2 12 3.79086 12 6C12 6.39453 12.0571 6.77572 12.1635 7.13575L8.8066 9.14991C8.08453 8.43879 7.09351 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C7.09346 16 8.08445 15.5612 8.80651 14.8502L12.1635 16.8644C12.0571 17.2244 12 17.6055 12 18C12 20.2091 13.7909 22 16 22C18.2091 22 20 20.2091 20 18C20 15.7909 18.2091 14 16 14C14.9065 14 13.9155 14.4388 13.1934 15.1499L9.83646 13.1358C9.94288 12.7757 10 12.3945 10 12C10 11.6055 9.94289 11.2244 9.83649 10.8644L13.1935 8.85017C13.9155 9.56124 14.9065 10 16 10C18.2091 10 20 8.20914 20 6C20 3.79086 18.2091 2 16 2Z"
  }));
};
export default ShareFillIcon;